import {
  getUserInfo,
  settingDetail,
  enterpriseSettingsApi,
} from '../../http/api'
const state = {
  userInfo: localStorage.userInfo || {},
  token: localStorage.token || '',
  settingDetail: {},
  enterpriseSettings: {},
  enterpriseGlobalObj: {
    enterpriseId: '',
    enterpriseName: '',
  },
}
const getters = {}
const mutations = {
  changeKey(state, payload) {
    for (let i in payload) {
      state[i] = payload[i]
    }
  },
}
const actions = {
  async getUserInfoFunc({ commit }, params) {
    const data = await getUserInfo(params)
    commit('changeKey', { userInfo: data })
    return data
  },
  async getSettingDetail({ commit }, params) {
    const data = await settingDetail(params)
    commit('changeKey', { settingDetail: data })
    return data
  },
  async getEnterpriseSettings({ commit }, params) {
    const res = await enterpriseSettingsApi(params)
    const data = res.data || {}
    commit('changeKey', { enterpriseSettings: data })
    return data
  },
}
export default { state, getters, mutations, actions }
